/**
 * Copyright (c) 2020 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import ParticipantGenderComponent from './participant.gender.component';
import { clearUpdateParticipantGenderError, hideModal, updateParticipantGender } from '../../actions/actions';

export const mapStateToProps = (state) => {
  return {
    error: state.subject.errorUpdateParticipantGender,
    isLoading: state.subject.isLoadingParticipantGender,
    currentGender: state.subject.phi.subjectInfo.data.participant.gender,
    participantId: state.subject.phi.subjectInfo.data.participant.subjectId
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    hide: () => {
      dispatch(hideModal());
      dispatch(clearUpdateParticipantGenderError());
    },
    updateParticipantGender: (participantId, payload) => {
      dispatch(updateParticipantGender(participantId, payload));
    }
  };
};

const ParticipantGenderModalContainer = connect(mapStateToProps, mapDispatchToProps)(ParticipantGenderComponent);

export default ParticipantGenderModalContainer;
